export const api = {
  mailNotification: '/mail-notification',
  taxInvoiceSummaryReport: '/tax-invoice-summary-report',
  taxInvoiceByProductReport: '/tax-invoice-details-report',
  saleProductReport: '/sale-product-report',
  cvAllocationReport: '/cv-allocation-report',
  cwWbDetailReport: '/cw-wb-detail-report',
  eWalletReports: '/ewallet/statement-report',
  eWalletPopSalesReport: '/ewallet/sales-statement-report',
  eWalletPopTransferReport: '/ewallet/transfer-statement-report',
  eWalletPopAdjustmentReport: '/ewallet/adjustment-statement-report',
  eWalletPopWithdrawalReport: '/ewallet/withdrawal-statement-report',
  eWalletPopWithdrawalPendingReport: '/ewallet/withdrawal-pending-statement-report',
  eWalletPopNonWithdrawalReport: '/ewallet/non-withdrawal-statement-report',
  eWalletPopDepositReport: '/ewallet/deposit-statement-report',
  eWalletPopBonusWBReport: '/ewallet/welcome-bonus-statement-report',
  eWalletPopBonusCOMReport: '/ewallet/bonus-commission-statement-report',
  eWalletPopWithdrawalChargesReport: '/ewallet/withdrawal-charges-statement-report',
  eWalletPopOthersReport: '/ewallet/others-statement-report',
  eWalletIndividualReport: '/ewallet/individual-statement-report',
  stockistCommissionReport: '/stockist-commission-report',
  taiwanPurchaseReport: '/report/taiwan-purchase-report',
  memberBvSvInfoReport: '/member/sv-bv-report',
  visitorHistoryList: '/report/visitor-history',
  visitorHistoryDownload: '/report/visitor-history-download',
  eInvoiceSaleReport: '/e-invoice-sales-report/download',
  eInvoiceBonusReport: '/e-invoice-bonus-report/download',
}
